import { resetIframes } from "./loadScenes.js";
import { sendEvent } from "./events.js";

const infoHotspotIcon = new URL("../assets/pc-white-nobg.png", import.meta.url);
const xIcon = new URL("../SVG/close-line.svg", import.meta.url);
const rightChev = new URL("../SVG/chevron-right.svg", import.meta.url);
const leftChev = new URL("../SVG/chevron-left.svg", import.meta.url);

const app = document.getElementById("app");

const removeInjectedHeader = (modal) => {
    const headerToRemove = modal.querySelector(".info-hotspot-header");
    headerToRemove.style.display = "none";
};

export function createInfoHotspotElement(hotspot) {
    // Create hotspot wrapper
    let wrapper = document.createElement("div");
    wrapper.classList.add("hotspot");
    wrapper.classList.add("info-hotspot");

    // Create hotspot/tooltip header
    let header = document.createElement("div");
    header.classList.add("info-hotspot-header");
    hotspot.class && header.classList.add(hotspot.class);

    // Create image element
    let iconWrapper = document.createElement("div");
    iconWrapper.classList.add("info-hotspot-icon-wrapper");
    let icon = document.createElement("img");
    icon.src = `${infoHotspotIcon}`;
    icon.classList.add("info-hotspot-icon");
    iconWrapper.appendChild(icon);

    // Create title element
    const titleWrapper = document.createElement("div");
    titleWrapper.classList.add("info-hotspot-title-wrapper");
    const title = document.createElement("div");
    title.classList.add("info-hotspot-title");
    title.innerHTML = hotspot.title;
    titleWrapper.appendChild(title);

    // Create close element
    let closeWrapper = document.createElement("div");
    closeWrapper.classList.add("info-hotspot-close-wrapper");
    let closeIcon = document.createElement("img");
    closeIcon.src = `${xIcon}`;
    closeIcon.classList.add("info-hotspot-close-icon");
    closeWrapper.appendChild(closeIcon);

    // Construct header element
    header.appendChild(iconWrapper);
    header.appendChild(titleWrapper);
    header.appendChild(closeWrapper);

    // Create content element (left side of modal)
    const content = document.createElement("div");
    content.classList.add("info-hotspot-content");

    // Create text element
    const textContent = document.createElement("div");
    textContent.classList.add("product-txt-container");
    const textWrapper = document.createElement("div");
    textWrapper.classList.add("product-txt-wrapper");
    const subhead = document.createElement("h2");
    subhead.classList.add("product-txt-subhead");
    hotspot.subhead
        ? (subhead.innerHTML = hotspot.subhead)
        : (subhead.innerHTML = hotspot.title);
    const text = document.createElement("div");
    text.innerHTML = hotspot.text;
    text.classList.add("product-txt");

    // Set up recipes
    const recipes = document.createElement("div");
    recipes.classList.add("recipes");

    // Recipe section header element
    const recipesHeader = document.createElement("h2");
    recipesHeader.classList.add("recipes-header");
    recipesHeader.textContent = "Recipes to Try:";

    recipes.appendChild(recipesHeader);

    // Create grid element for "list" of recipes
    const recipesList = document.createElement("div");
    recipesList.classList.add("recipes-list");

    hotspot.recipes?.map((_recipe, i) => {
        const recipe_el = document.createElement("div");
        const recipe_title = document.createElement("span");
        const recipe_link = document.createElement("a");

        const recipeImage = hotspot.recipes[i].element;

        recipe_title.classList.add("recipe-title");
        recipe_title.innerHTML = hotspot.recipes[i].title;
        recipe_title.href = hotspot.recipes[i].link;

        recipe_link.classList.add("recipe-link");
        recipe_link.href = hotspot.recipes[i].link;
        recipe_link.setAttribute("target", "_blank");
        recipe_link.setAttribute("rel", "noreferrer");

        recipe_link.innerHTML = recipeImage;
        recipe_link.appendChild(recipe_title);
        recipe_el.appendChild(recipe_link);
        recipesList.appendChild(recipe_el);
    });

    if (!hotspot.recipes) {
        recipes.style.display = "none";
        recipesHeader.innerHTML = "";
    }
    recipes.appendChild(recipesList);

    textWrapper.appendChild(subhead);
    textWrapper.appendChild(text);
    textWrapper.appendChild(recipes);
    textContent.appendChild(textWrapper);

    // Set up carousel
    const carousel_container = document.createElement("div");
    carousel_container.classList.add("carousel_container");

    const carousel = document.createElement("div");
    carousel.classList.add("carousel");

    const carouselImages = document.createElement("div");
    carouselImages.classList.add("carousel-images");

    const carouselNav = document.createElement("div");
    carouselNav.classList.add("carousel-nav");

    const carouselNext = document.createElement("img");
    carouselNext.src = `${rightChev}`;
    carouselNext.classList.add("carousel-button");
    carouselNext.classList.add("next");
    carouselNext.setAttribute("id", "next");

    const carouselPrev = document.createElement("img");
    carouselPrev.src = `${leftChev}`;
    carouselPrev.classList.add("carousel-button");
    carouselPrev.classList.add("previous");
    carouselPrev.setAttribute("id", "previous");

    const carousel_pagination = document.createElement("ul");
    carousel_pagination.classList.add("carousel-pagination");

    // Create carousel videos
    hotspot?.videos &&
        hotspot.videos.map((_video, i) => {
            const carousel_bullet = document.createElement("li");
            carousel_bullet.classList.add("carousel-bullet");

            const video = document.createElement("div");
            video.innerHTML = hotspot.videos[i];
            video.classList.add("iframe_container__video");

            carousel_pagination.appendChild(carousel_bullet);

            carouselImages.append(video);
        });

    // Create carousel images
    hotspot?.images &&
        hotspot.images.map((_image, i) => {
            const carousel_bullet = document.createElement("li");
            carousel_bullet.classList.add("carousel-bullet");
            const productImage = document.createElement("div");
            productImage.setAttribute("id", "product-image");
            const productImageSrc = hotspot.images[i];
            productImage.innerHTML = productImageSrc;
            carouselImages.appendChild(productImage);
            carousel_pagination.appendChild(carousel_bullet);
            carousel_container.appendChild(carousel_pagination);
            hotspot.images[i].contain === "contain" &&
                productImageSrc.classList.add("contain");
        });

    

    carousel.appendChild(carouselImages);
    carouselNav.appendChild(carouselNext);
    carouselNav.appendChild(carouselPrev);
    carousel_container.appendChild(carouselNav);

    carousel_container.appendChild(carousel);

    content.appendChild(textContent);
    content.appendChild(carousel_container);

    wrapper.appendChild(header);
    wrapper.appendChild(content);

    // Map everything above to modal container
    const modal = document.createElement("div");
    modal.innerHTML = wrapper.innerHTML;
    modal.classList.add("info-hotspot-modal");

    // Resets modal on close
    function reset_modal(e) {
        setTimeout(() => {
            const pdf = "pdf";
            modal.classList.contains(!pdf) &&
                modal.querySelector(".product-txt-container").scrollTo(0, 0);
            slideTo(0);
            resetIframes();
        }, 500);
    }

    // Opens a modal
    const openModal = function (e) {
        if (!hotspot.pdf) {
            app.appendChild(modal);

            setTimeout(() => {
                wrapper.classList.add("visible");
                modal.classList.add("visible");
            }, 500);
        } else {
            wrapper.classList.add("visible");
            modal.classList.add("visible");
        }

        if (!document.body.classList.contains("tour-accepted")) {
            sendEvent(
                "Experience",
                "Opened Product Info",
                titleWrapper.textContent
            );
        }
    };

    // Closes a modal
    const closeModal = function (e) {
        try {
            modal.removeEventListener("click", closeModal);
        } catch (e) {
            console.log(e);
        }
        

        modal.classList.remove("visible");
        reset_modal();

        if (!document.body.classList.contains("tour-accepted")) {
            sendEvent(
                "experience",
                "closed product info",
                titleWrapper.textContent
            );
        }
    };

    const handleClickOutside = function (e) {
        if (e.target === modal && modal.classList.contains("visible")) {
            closeModal(e);
            modal.removeEventListener("mouseover", handleClickOutside);
        }
    }

    wrapper
        .querySelector(".info-hotspot-header")
        .addEventListener("click", openModal);

    modal
        .querySelector(".info-hotspot-close-wrapper")
        .addEventListener("click", closeModal);
    modal.addEventListener("click", handleClickOutside);

    icon.addEventListener("mouseover", (e) => {
        if (!document.body.classList.contains("tour-accepted")) {
            sendEvent(
                "experience",
                "hovered product info button",
                titleWrapper.textContent
            );
        }
    });

    // --------------------------------------------
    // --------------------------------------------
    // ================ CAROUSEL ==================
    // --------------------------------------------
    // --------------------------------------------

    // Creates handlers for carousel
    const nextBtn = modal.querySelector("#next");
    const prevBtn = modal.querySelector("#previous");

    const carouselImgs = modal.querySelector(".carousel-images");
    const numberOfImages = modal.querySelectorAll(
        ".carousel-images > *"
    ).length;
    const pagination = modal.querySelector(".carousel-pagination");
    const bullets = [].slice.call(modal.querySelectorAll(".carousel-bullet"));

    let currentIndex = 0;
    let percentage = 100;

    let touchstartX = 0;
    let touchendX = 0;

    function handleGesture() {
        if (touchendX < touchstartX && currentIndex !== numberOfImages - 1) {
            nextBtn.click();
        }
        if (touchendX > touchstartX && currentIndex !== 0) {
            prevBtn.click();
        }
    }

    carouselImgs.addEventListener(
        "touchstart",
        (e) => {
            touchstartX = e.changedTouches[0].pageX;
        },
        { passive: true }
    );

    carouselImgs.addEventListener("touchend", (e) => {
        touchendX = e.changedTouches[0].pageX;
        handleGesture();
    });

    carouselImgs.addEventListener("mousedown", (e) => {
        touchstartX = e.pageX;
    });

    carouselImgs.addEventListener("mouseup", (e) => {
        touchendX = e.pageX;
        handleGesture();
    });

    carouselImgs.addEventListener(
        "wheel",
        (e) => {
            let wheel_direction = e.deltaY * 1;
            if (Math.sign(wheel_direction) === -1) {
                if (currentIndex !== 0) prevBtn.click();
            } else {
                if (currentIndex !== numberOfImages - 1) nextBtn.click();
            }
        },
        { passive: true }
    );

    function next(e) {
        const index = currentIndex + 1;
        slideTo(index);
        // sendEvent('experience', 'changed product image', `slide #${index}`)
    }

    function prev(e) {
        slideTo(currentIndex - 1);
        // sendEvent('experience', 'changed product image', `slide #${index}`)
    }

    function slideTo(index) {
        index =
            index < 0
                ? numberOfImages - 1
                : index >= numberOfImages
                ? 0
                : index;
        carouselImgs.style.WebkitTransform = carouselImgs.style.transform =
            "translate(-" + index * percentage + "%, 0)";
        bullets[currentIndex]?.classList.contains("active-bullet") &&
            bullets[currentIndex]?.classList.remove("active-bullet");
        bullets[index]?.classList.add("active-bullet");
        currentIndex = index;
    }

    hotspot.images && bullets[currentIndex].classList.add("active-bullet");
    prevBtn.addEventListener("click", prev, false);
    nextBtn.addEventListener("click", next, false);

    pagination &&
        pagination.addEventListener(
            "click",
            function (e) {
                let index = bullets.indexOf(e.target);
                if (index !== -1 && index !== currentIndex) {
                    slideTo(index);
                }
            },
            false
        );

    // For modals with only one element...

    // Remove all child nodes
    function removeAllChildNodes(parent) {
        while (parent.firstChild) {
            parent.removeChild(parent.firstChild);
        }
    }

    if (hotspot?.pdf) {
        app.appendChild(modal);
        const modalContainer = modal;
        modalContainer.classList.add("fullModal");
        const modalContent = modal.querySelector("div.info-hotspot-content");
        modalContent.classList.add("fullContent");
    
        removeAllChildNodes(modalContent);
        const iframeContainer = document.createElement("div");
        iframeContainer.classList.add("iframeContainer");
        iframeContainer.innerHTML = hotspot.text;

        var isAltText = false;
        if (hotspot.altText) {
            const toggleContainer = document.createElement("div");
            toggleContainer.classList.add("toggleContainer");
            
            const toggleSpanUS = document.createElement("span");
            toggleSpanUS.textContent = "US";
            toggleSpanUS.classList.add("toggleSpanUS");
            
            const toggleSpanCA = document.createElement("span");
            toggleSpanCA.textContent = "CA";
            toggleSpanCA.classList.add("toggleSpanCA");

            const toggle = document.createElement("label");
            toggle.classList.add("toggle");
            toggle.setAttribute("for", "myToggle");
        
            const toggleInput = document.createElement("input");
            toggleInput.classList.add("toggle__input");
            toggleInput.setAttribute("name", "");
            toggleInput.setAttribute("type", "checkbox");
            toggleInput.setAttribute("id", "myToggle");
        
            const toggleFill = document.createElement("div");
            toggleFill.classList.add("toggle__fill");

            toggleInput.addEventListener("change", () => {
                isAltText = !isAltText;
                iframeContainer.innerHTML = isAltText ? hotspot.altText : hotspot.text;
                if (isAltText) {
                    leftSpan.classList.add(".toggleSpanHidden")
                    rightSpan.classList.remove(".toggleSpanHidden")
                } else {
                    leftSpan.classList.remove(".toggleSpanHidden")
                    rightSpan.classList.add(".toggleSpanHidden")
                }
            });
        
            toggle.appendChild(toggleInput);
            toggle.appendChild(toggleFill);

            toggleContainer.appendChild(toggleSpanUS);
            toggleContainer.appendChild(toggle);
            toggleContainer.appendChild(toggleSpanCA);
            modalContent.appendChild(toggleContainer);
        } 
        
        modalContent.appendChild(iframeContainer);
    }

    // If hotspot data set has key "singlePaneModal" (may contain "images" too, or any other key)
    if (hotspot?.singlePaneModal) {
        removeInjectedHeader(modal);
        const modalContainer = modal;
        modalContainer.classList.add("singlePaneModal");
        modalContainer.classList.add("fullModal");

        const modalContent = modal.querySelector("div.info-hotspot-content");

        if (hotspot?.video) {
            modalContent.classList.add("singlePaneVideo");
        }

        modalContent.classList.add("singlePaneContent");
        removeAllChildNodes(modalContent);
        const modalContentInner = document.createElement("div");
        modalContentInner.classList.add("singlePaneContentInner");
        modalContentInner.innerHTML = hotspot.text;
        modalContent.appendChild(modalContentInner);

        const createModalCloseIcon = (modal) => {
            const modalCloseBtn = document.createElement("a");
            modalCloseBtn.classList.add("info-hotspot-content--close");
            modalCloseBtn.innerText = "X";
            modal.appendChild(modalCloseBtn);
        };
        createModalCloseIcon(modalContentInner);
        const closeIcon = modal.querySelector(".info-hotspot-content--close");

        closeIcon.addEventListener("click", closeModal);
    }

    return wrapper;
}
